import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import Calendar      from 'app/components/common/calendar';
import Dropdown      from 'app/components/common/dropdown';
import Icon          from 'app/components/common/icon';
import StandardInput from 'app/components/common/standard-input';

const frmt = 'YYYY-MM-DD';
const userFrmt = 'MMMM D, YYYY';
const textInputFrmt = 'MM/DD/YYYY';

class DatePicker extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      monthDateStr: null,
      textInputStr: null,
    };

    this.refDropdown = React.createRef();

    this.onChangeTextInput = this.onChangeTextInput.bind(this);
    this.onClickSetTextInput = this.onClickSetTextInput.bind(this);
    this.onKeyUpTextInput = this.onKeyUpTextInput.bind(this);
    this.onChangeCalendarMonth = this.onChangeCalendarMonth.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onCloseDropdown = this.onCloseDropdown.bind(this);
  }

  get monthDateStr() {
    return this.state.monthDateStr || this.props.dateStr || undefined;
  }

  get textInputStr() {
    if (this.state.textInputStr != null) return this.state.textInputStr;
    if (!this.props.dateStr) return '';
    return moment.utc(this.props.dateStr).format(textInputFrmt);
  }

  get hasTextInput() {
    return this.state.textInputStr != null;
  }

  get canSubmitTextInput() {
    const momVal = moment(this.state.textInputStr, textInputFrmt);
    if (!momVal.isValid()) return false;
    if (this.props.noFuture && momVal.isAfter()) return false;
    return true;
  }

  onChangeCalendarMonth(monthDateStr) {
    this.setState({monthDateStr});
  }

  onSelectDate(dateStr) {
    this.props.onChange(dateStr);
    this.refDropdown.current.close();
  }

  onClear() {
    this.props.onChange(null);
  }

  onCloseDropdown() {
    this.setState({monthDateStr: null, textInputStr: null});
  }

  onChangeTextInput(event) {
    const textInputStr = event.target.value;
    this.setState({textInputStr});
  }

  onKeyUpTextInput(event) {
    if (event.key === 'Enter') {
      this.onClickSetTextInput();
    }
  }

  onClickSetTextInput() {
    if (!this.canSubmitTextInput) return;
    const momVal = moment(this.state.textInputStr, textInputFrmt);
    this.onSelectDate(momVal.format(frmt));
  }

  renderDropdownButton() {
    const { dateStr, placeholder } = this.props;
    return dateStr
      ? moment.utc(dateStr, frmt).format(userFrmt)
      : placeholder;
  }

  renderDropdownMenu() {
    const { dateStr, noFuture } = this.props;
    return (
      <div className="date-picker-menu">
        <div className="date-picker-menu-text-input-con">
          <StandardInput
            className="date-picker-menu-text-input"
            name="dateStr"
            label="MM/DD/YYYY"
            value={this.textInputStr}
            onChange={this.onChangeTextInput}
            onKeyUp={this.onKeyUpTextInput}
          />
          {this.hasTextInput && (
            <button className="btn" onClick={this.onClickSetTextInput} disabled={!this.canSubmitTextInput}>Set</button>
          )}
        </div>
        <Calendar
          startDateStr={dateStr}
          monthDateStr={this.monthDateStr}
          onChangeMonthDate={this.onChangeCalendarMonth}
          onSelectDate={this.onSelectDate}
          noFuture={noFuture}
        />
      </div>
    );
  }

  render() {
    const { className, ddAlign, dateStr, validations, disabled, name, allowClear } = this.props;
    const filledClass = dateStr ? 'filled' : 'empty';
    const validationMessage = _.get(validations, `${name}[0]`);
    const showClear = !!(allowClear && dateStr);

    return (
      <Dropdown
        className={`date-picker ${className} ${filledClass}`}
        align={ddAlign}
        button={this.renderDropdownButton()}
        menu={this.renderDropdownMenu()}
        ref={this.refDropdown}
        onClose={this.onCloseDropdown}
        validationMessage={validationMessage}
        disabled={disabled}
        onClear={showClear ? this.onClear : null}
      />
    );
  }

}

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  dateStr: PropTypes.string,
  ddAlign: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  validations: PropTypes.object,
  disabled: PropTypes.bool,
  allowClear: PropTypes.bool,
  noFuture: PropTypes.bool, // TODO: use max date instead, cuz timezones
};

DatePicker.defaultProps = {
  className: '',
  ddAlign: 'right',
  placeholder: 'Date',
  name: 'n/a',
  validations: {},
  disabled: false,
  allowClear: false,
  noFuture: false,
};

export default DatePicker;
